var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "../themes/styled";
import Text from "../text/Text";
import Box from "../box/Box";
import { themeGet } from "@styled-system/theme-get";
import { List, ListItem } from "../text";
function getColor(p) {
    if (p.color) {
        return p.color.indexOf("#") !== -1 ? p.color : themeGet("colors.".concat(p.color))(p);
    }
    else {
        return "black";
    }
}
function stripTags(el, arr, stripSrTags, srClass) {
    if (stripSrTags === void 0) { stripSrTags = true; }
    if (srClass === void 0) { srClass = "sr-only"; }
    if (el === "") {
        return;
    }
    if (Array.isArray(el)) {
        el.forEach(function (child) {
            arr.push(stripTags(child, arr, stripSrTags, srClass));
        });
        return arr;
    }
    if (stripSrTags && el.includes(srClass)) {
        var doc = new DOMParser().parseFromString(el.toString(), "text/html");
        if (doc) {
            doc.querySelectorAll("." + srClass).forEach(function (e) { return e.remove(); });
            el = doc.body.innerText;
        }
    }
    return el.toString().replace(/<[^>]*>/g, "");
}
var Container = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    * {\n        color: ", ";\n    }\n"], ["\n    * {\n        color: ", ";\n    }\n"])), getColor);
var Label = function (_a) {
    var label = _a.label, htmlText = _a.htmlText, children = _a.children, rest = __rest(_a, ["label", "htmlText", "children"]);
    return (React.createElement(Box, __assign({ display: "flex", alignItems: "center" }, rest),
        React.createElement(Text, { fontWeight: "bold", display: "inline", mr: 2 },
            label,
            ":"),
        htmlText ? React.createElement(Text, { dangerouslySetInnerHTML: { __html: htmlText } }) : React.createElement(Text, null, children)));
};
var Time = function (_a) {
    var _b, _c, _d, _e;
    var label = _a.label, time = _a.time, rest = __rest(_a, ["label", "time"]);
    var h = (_c = (_b = time.match(/(?<hours>\d+)H/)) === null || _b === void 0 ? void 0 : _b.groups) === null || _c === void 0 ? void 0 : _c.hours;
    var m = (_e = (_d = time.match(/(?<minutes>\d+)M/)) === null || _d === void 0 ? void 0 : _d.groups) === null || _e === void 0 ? void 0 : _e.minutes;
    var hours = h ? parseInt(h) : null;
    var minutes = m ? parseInt(m) : null;
    return (React.createElement(Label, __assign({ label: label }, rest),
        hours ? "".concat(hours, " hour").concat(hours > 1 ? "s" : "", " ") : null,
        minutes ? "".concat(minutes, " min").concat(minutes > 1 ? "s" : "") : null));
};
var ListOrString = function (_a) {
    var label = _a.label, data = _a.data, _b = _a.as, as = _b === void 0 ? "ul" : _b, rest = __rest(_a, ["label", "data", "as"]);
    var isList = Array.isArray(data);
    return (React.createElement(Box, __assign({}, rest),
        React.createElement(Text, { fontWeight: "bold", display: isList ? "block" : "inline", mr: 2, mb: 3 },
            label,
            ":"),
        isList ? (React.createElement(List, { as: as }, data.map(function (item, i) { return (React.createElement(ListItem, { key: "".concat(label.toLowerCase().replace(" ", ""), "_").concat(i), lineHeight: 5, mb: 2, ml: 4, dangerouslySetInnerHTML: {
                __html: item,
            } })); }))) : (React.createElement(Text, { lineHeight: 5, display: "inline" }, data))));
};
export function Recipe(_a) {
    var recipe = _a.recipe, _b = _a.headlineColor, headlineColor = _b === void 0 ? "black" : _b, _c = _a.textColor, textColor = _c === void 0 ? "black" : _c, boxProps = __rest(_a, ["recipe", "headlineColor", "textColor"]);
    var jsonData = {};
    Object.keys(recipe).map(function (key) {
        jsonData[key] = stripTags(recipe[key], []);
    });
    var json = __assign(__assign({}, jsonData), { "@context": "https://schema.org/", "@type": "Recipe", publisher: {
            "@type": "Organization",
            name: "Onnit",
            logo: {
                "@type": "ImageObject",
                url: "https://onnits3.imgix.net/interface/branding/touch-icon.png?w=600&h=600",
                width: 600,
                height: 600,
            },
        } });
    if (recipe.author) {
        json.author = {
            "@type": "Person",
            name: recipe.author,
        };
    }
    return (React.createElement(Box, __assign({}, boxProps),
        React.createElement("script", { type: "application/ld+json" }, JSON.stringify(json)),
        React.createElement(Text, { typeStyle: "copyDisplay02", mb: [4, 4, 6], color: headlineColor, dangerouslySetInnerHTML: { __html: recipe.name } }),
        React.createElement(Container, { color: textColor },
            React.createElement(Box, { display: "flex", flexWrap: "wrap", mb: 1 },
                React.createElement(Label, { label: "Yields", py: 1, mr: 3, htmlText: recipe.recipeYield }),
                recipe.prepTime && React.createElement(Time, { label: "Prep Time", time: recipe.prepTime, py: 1, mr: 3 }),
                recipe.cookTime && React.createElement(Time, { label: "Cook Time", time: recipe.cookTime, py: 1, mr: 3 }),
                recipe.totalTime && React.createElement(Time, { label: "Total Time", time: recipe.totalTime, py: 1, mr: 3 })),
            React.createElement(ListOrString, { py: 4, mb: 2, label: "Directions", data: recipe.recipeInstructions, as: "ol" }),
            React.createElement(ListOrString, { label: "Ingredients", data: recipe.recipeIngredient }))));
}
var templateObject_1;
//# sourceMappingURL=Recipe.js.map